import { render } from "./migration-requests.vue?vue&type=template&id=58b82557&scoped=true"
import script from "./migration-requests.vue?vue&type=script&lang=ts"
export * from "./migration-requests.vue?vue&type=script&lang=ts"

import "./migration-requests.vue?vue&type=style&index=0&id=58b82557&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58b82557"

export default script